import { render, staticRenderFns } from "./create-systemcode.vue?vue&type=template&id=38c49ebe&"
import script from "./create-systemcode.vue?vue&type=script&lang=ts&"
export * from "./create-systemcode.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports